import Box from '@material-ui/core/Box';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import BrowserDetector from '../../lib/browser';

const BrowserCheck = () => {
  const [browserUnsupported, setBrowserUnsupported] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (!(new BrowserDetector).isSupported()) {
      setBrowserUnsupported(true);
    }
  }, []);

  return browserUnsupported &&
    (
      <Box className="browser-unsupported">
        <a href="https://browser-update.org/" target="_blank" rel="noopener noreferrer">{
          t('browser.unsupportedVersion', 'Your browser version is not fully compatible, please update to the latest version.')
        }</a></Box>
    ) || null;
}

export default BrowserCheck;
